import React from 'react';

export default function FirstStaticBottomRow({ data, borderClasses }) {
    return (
        <section className='flex flex-row gap-5 mt-5'>
            <article className='flex flex-col gap-y-2 w-3/4'>
                <h1 className='w-full font-bold text-center'>Vendor Quote History</h1>
                <section className='w-full border overflow-auto max-h-[400px]'>
                    <table className='relative w-full'>
                        <thead className='sticky top-0 text-white bg-blue-primary'>
                            <tr>
                                <th className={borderClasses}>Date</th>
                                <th className={'border-r-[1px] border-white pl-4'}>Vendor</th>
                                <th className={borderClasses}>CC</th>
                                <th className={`${borderClasses} text-center`}>QTY QTD</th>
                                <th className={borderClasses}>Price</th>
                                <th className={`${borderClasses} text-center`}>Delivery</th>
                                <th className={borderClasses}>Trace</th>
                                <th className={borderClasses}>Tagged By</th>
                                <th className={borderClasses}>Tag Date</th>
                                <th className={borderClasses}>AC_AEX_VENDOR</th>
                                <th className='px-1'>Type QTD</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.vendorQuoteHistory?.map((data, index) => {
                                return (
                                    <tr key={index} className='border-b last:!border-none'>
                                        <td className='px-1'>{data.createdDate}</td>
                                        <td className='py-3 pl-4'>
                                            <h1
                                                className={
                                                    ' ' + (data?.highlighted && 'bg-yellow-300 bg-opacity-40 p-1 w-fit ')
                                                }
                                            >
                                                {data.vendorName}
                                            </h1>
                                        </td>
                                        <td className='px-1'>{data.conditionCode}</td>
                                        <td className='px-1 text-center'>{data.quantityQuoted}</td>
                                        <td className='px-1'>
                                            {data.price?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                        </td>
                                        <td className='px-1 text-center'>{data.delivery}</td>
                                        <td className='px-1'>{data.trace}</td>
                                        <td className='px-1'>{data.taggedBy}</td>
                                        <td className='px-1'>{data.tagDate}</td>
                                        <td className='px-1'>{data.aexVendor}</td>
                                        <td className='px-1'>{data.typeQuoted}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
            </article>
            <article className='flex flex-col gap-y-2 w-1/4'>
                <h1 className='w-full font-bold text-center'>Quote History</h1>
                <section className='w-full overflow-auto border max-h-[400px]'>
                    <table className='relative w-full'>
                        <thead className='sticky top-0 text-white bg-blue-primary'>
                            <tr>
                                <th className='border-r-[1px] border-white pl-4'>Customer</th>
                                <th className={borderClasses}>CC</th>
                                <th className={borderClasses}>Price</th>
                                <th className='px-1'>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.quoteHistory?.map((data, index) => {
                                return (
                                    <tr key={index} className='border-b last:!border-none'>
                                        <td
                                            className={
                                                data?.highlightIfAirline
                                                    ? 'py-3 pl-4 border-4 border-green-600 rounded-md'
                                                    : 'py-3 pl-4'
                                            }
                                        >
                                            <h1
                                                className={
                                                    ' ' + (data?.highlighted && 'bg-yellow-300 bg-opacity-40 p-1 w-fit')
                                                }
                                            >
                                                {data.customer}
                                            </h1>
                                        </td>
                                        <td className='px-1'>{data.conditionCode}</td>
                                        <td className='px-1'>
                                            {data.price?.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                                        </td>
                                        <td className='px-1'>{data.createdDate}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </section>
            </article>
        </section>
    );
}
